module.exports = __webpack_public_path__ + "static/media/square-logo-transparent-4.0f0526d0.png";